var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel3"},[_c('div',{staticStyle:{"min-height":"296px"},attrs:{"id":'charts' + _vm.Id}}),_c('mx-column-data',{attrs:{"config":_vm.config,"dataconfig":_vm.dataconfig},on:{"change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }